<template>
    <tr class="font-costea text-t12 border-b pb-3 h-14">
      <td>
        <button @click="removeManoObra" class="mx-2 cursor-pointer bg-costeaContainer text-costeaGray hover:bg-costeaSalmonDisabled hover:text-costeaSalmon rounded-full w-5 h-5 flex justify-center items-center"><i class="ri-close-fill"></i></button>
      </td>
      <td>
        <input
          v-model="nombreMOD"
          name="tipoIdentificacion"
          id="tipoIdentificacion"
          class="
            bg-white
            border-gray-200
            border-solid
            border-2
            w-10/12
            h-10
            justify-start
            items-center
            outline-none
            py-2
            px-3
            rounded-md
            text-t14"/>
      </td>
      <td>
        <input
          v-model="costoMOD"
          type="number"
          name="area"
          id="area"
          step="0.01"
          min="0"
          max="999999999"
          class="
            bg-white
            border-gray-200
            border-solid
            border-2
            w-10/12
            h-10
            flex
            justify-start
            items-center
            outline-none
            py-2
            px-3
            rounded-md
            text-t14"
            placeholder="$ --"/>
      </td>
      <td>
        <input
          type="number"
          v-model="tiempoStandar"
          step="0.01"
          min="0"
          placeholder="0"
          max="9999"
          name="tiempo"
          id="tiempo"
          class="
            bg-white
            border-gray-200
            border-solid
            border-2  
            w-6/12
            h-10
            flex
            justify-start
            items-center
            outline-none
            py-2
            px-3
            rounded-md
            text-t14 text-center"
        />
      </td>
      <td>
        <span class="text-t14 cursor-pointer text-costeaGray">$ {{calcManoObra}}</span>
      </td>
      <td>
        <button @click="addManoObra" class="ring-4 ring-costeaPrimaryDisabled ring-opacity-30 mx-2 cursor-pointer bg-costeaPrimaryDisabled text-costeaPrimary hover:bg-costeaPrimary hover:text-white rounded-full w-5 h-5 flex justify-center items-center"><i class="ri-check-fill"></i></button>
      </td>
    </tr>
</template>

<script>
import axios from 'axios'
import {mapState} from 'vuex'
export default {
    data(){
        return{
            nombreMOD:'',
            costoMOD:'',
            costoManoObra: '',
            tiempoStandar: '',
            costoPorArea: 0,

        }
    },
    computed:{
        ...mapState(['costea']),
        calcManoObra(){
          let total = 0
          let costoHora = this.costoMOD
          let tiempoStandar = this.tiempoStandar
          parseFloat(total)
          parseInt(tiempoStandar)
          parseInt(costoHora)
          if(!tiempoStandar || tiempoStandar == 0){
            total = costoHora * 1
          }else{
            total = costoHora * tiempoStandar
          }
          total = total.toFixed(2)
          return total
        },
        calcSubTotalManoObra(subtotal){
          let total = 0
          total += subtotal
          return total
        },
    },
    methods:{
      removeManoObra(){
        this.$emit('removeManoObra', -1)
      },
      getProductById(){
        axios.get(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}producto-view/${this.$route.params.id}`)
        .then(
          res =>{
            this.products = res.data.data
          })
        .catch(error => console.log(error))
      },
      addManoObra(){
        axios.post(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}mod-add`,
        {
          id_area: '',
          nombre_mod: this.nombreMOD,
          costo_hora_hombre: this.costoMOD,
          tiempo_standar: this.tiempoStandar ? parseFloat(this.tiempoStandar) : '0',
          costo_por_area: this.calcManoObra
        }).then(response => {
          if(response.status === 200){
            let mods = [response.data.success.MOD.id]
            let prod = this.products.modirectas
            for(var i=0; i< prod.length; i++){
                mods.push(prod[i].mano_obra_directa_id)
            }
            axios.post(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}producto/mod-add/${this.$route.params.id}`, {mano_obra_directa_id: mods})
            .then(
                this.toggleModal(),
                this.removeManoObra()
            ).catch(error => console.log(error))
          }
        }
        ).catch(error => console.log(error))
      },
      toggleModal(){
        this.$emit('reloadData', true)
      },
    },
    mounted(){
      this.getProductById();
    }
};
</script>

<style>
</style>